/* eslint-disable */
import createApp from './app'

const { app, router, piniaStore } = createApp();
const {appid} = require("../kubeconfig.json");
const webAppDir = `@/../dist/${appid}/client`;

(async (r, a) => {
	await r.isReady()
		.then(() => {
			return Promise.all(r.currentRoute.value.matched
				.map(async (route) => {
					if (process.env.NODE_ENV === 'development' && route.components?.default?.asyncData) {
						return route.components.default.asyncData({
							store: piniaStore,
							route: r.currentRoute.value,
							host: window.location.host,
							env: process.env,
							staticPublicPath: '/',
							webAppDir: webAppDir
						});
					}
				}))
				.then(() => {
					const store = piniaStore;
					if (window.__INITIAL_STATE__) {
						for (let key in window.__INITIAL_STATE__) {
							if (window.__INITIAL_STATE__[key]) {
								try{
									store[key].$patch(window.__INITIAL_STATE__[key]);
								}
								catch (error) {
									store[key]= window.__INITIAL_STATE__[key];
								}
							}
						}
					} else {
						store.route = r.currentRoute.value;
					}
					window.__INITIAL_STATE__ = store.$state;
					for(let key in store) {
						if (store?.[key]?.['$state']) {
							window.__INITIAL_STATE__[key] = store[key].$state;
						}
					}
					a.mount('#app', true);
				});

		});
})(router, app);
